/**
 * Instagram carousel — posts from Thiruvambady Vineesh Marar.
 * Thumbnails saved in public/instagram/ (fetched from Instagram og:image).
 */
import { CONTACT, BRAND_NAME } from "./contactInfo";

const publicUrl = process.env.PUBLIC_URL || "";

export const INSTAGRAM_PROFILE = CONTACT.instagram;

const instagramPosts = [
  {
    image: "instagram/DLfTuJRTCXN.jpg",
    url: "https://www.instagram.com/p/DLfTuJRTCXN/",
    alt: "Thiruvambady Vineesh Marar — Instagram post",
  },
  {
    image: "instagram/DUsQc3Lj_a2.jpg",
    url: "https://www.instagram.com/reel/DUsQc3Lj_a2/",
    alt: "Playing along with ensemble — Instagram reel",
  },
  {
    image: "instagram/DLjGIjRP444.jpg",
    url: "https://www.instagram.com/p/DLjGIjRP444/",
    alt: "Thiruvambady Vineesh Marar — Instagram post",
  },
  {
    image: "instagram/DLfSMOevv0q.jpg",
    url: "https://www.instagram.com/p/DLfSMOevv0q/",
    alt: "Thiruvambady Vineesh Marar — Instagram post",
  },
  {
    image: "instagram/DKy5BysvBMp.jpg",
    url: "https://www.instagram.com/reel/DKy5BysvBMp/",
    alt: "Melam performance — Instagram reel",
  },
  {
    image: "instagram/DJY9DacJUNq.jpg",
    url: "https://www.instagram.com/reel/DJY9DacJUNq/",
    alt: "Thiruvambady Vineesh Marar — Instagram reel",
  },
  {
    image: "instagram/DInLh6YhNB3.jpg",
    url: "https://www.instagram.com/p/DInLh6YhNB3/",
    alt: "Thiruvambady Vineesh Marar — Instagram post",
  },
  {
    image: "instagram/DIT7CJ_BKB_.jpg",
    url: "https://www.instagram.com/reel/DIT7CJ_BKB_/",
    alt: "Ayyapan Temple Madathil Varavu — Instagram reel",
  },
  {
    image: "instagram/DIT6u7tBWyB.jpg",
    url: "https://www.instagram.com/p/DIT6u7tBWyB/",
    alt: "Thiruvambady Vineesh Marar — Instagram post",
  },
  {
    image: "instagram/DHKpZ3hpU2b.jpg",
    url: "https://www.instagram.com/p/DHKpZ3hpU2b/",
    alt: "Thiruvambady Vineesh Marar — Instagram post",
  },
  {
    image: "instagram/DDUviaCSTB6.jpg",
    url: "https://www.instagram.com/p/DDUviaCSTB6/",
    alt: "Thiruvambady Vineesh Marar — Instagram post",
  },
  {
    image: "instagram/DCcI9V5Sbo_.jpg",
    url: "https://www.instagram.com/p/DCcI9V5Sbo_/",
    alt: "Thiruvambady Vineesh Marar — Instagram post",
  },
  {
    image: "instagram/DCcI4KISIpL.jpg",
    url: "https://www.instagram.com/p/DCcI4KISIpL/",
    alt: "Thiruvambady Vineesh Marar — Instagram post",
  },
  {
    image: "instagram/C8XcHUyycJb.jpg",
    url: "https://www.instagram.com/p/C8XcHUyycJb/",
    alt: "Thiruvambady Vineesh Marar — Instagram post",
  },
  {
    image: "instagram/C8XcOJ8SiKG.jpg",
    url: "https://www.instagram.com/p/C8XcOJ8SiKG/",
    alt: "Thiruvambady Vineesh Marar — Instagram post",
  },
  {
    image: "instagram/C8Xb4kgSKX-.jpg",
    url: "https://www.instagram.com/p/C8Xb4kgSKX-/",
    alt: "Thiruvambady Vineesh Marar — Instagram post",
  },
  {
    image: "instagram/C6QHTK5rXA9.jpg",
    url: "https://www.instagram.com/p/C6QHTK5rXA9/",
    alt: "Recording session — Instagram post",
  },
  {
    image: "instagram/C3kGxkLLiP1.jpg",
    url: "https://www.instagram.com/p/C3kGxkLLiP1/",
    alt: "Thiruvambady Vineesh Marar — Instagram post",
  },
  {
    image: "instagram/C3Opfz1BAE5.jpg",
    url: "https://www.instagram.com/p/C3Opfz1BAE5/",
    alt: "Thiruvambady Vineesh Marar — Instagram post",
  },
  {
    image: "instagram/C242WalLDQ3.jpg",
    url: "https://www.instagram.com/p/C242WalLDQ3/",
    alt: "Thiruvambady Vineesh Marar — Instagram post",
  },
  {
    image: "instagram/C2xDrRRrlVJ.jpg",
    url: "https://www.instagram.com/p/C2xDrRRrlVJ/",
    alt: "Thiruvambady Vineesh Marar — Instagram post",
  },
  {
    image: "instagram/C2fdMoKpba-.jpg",
    url: "https://www.instagram.com/p/C2fdMoKpba-/",
    alt: "Thiruvambady Vineesh Marar — Instagram post",
  },
  {
    image: "instagram/C2JjxT0LDNt.jpg",
    url: "https://www.instagram.com/p/C2JjxT0LDNt/",
    alt: "Thiruvambady Vineesh Marar — Instagram post",
  },
  {
    image: "instagram/CzROvvKptOe.jpg",
    url: "https://www.instagram.com/p/CzROvvKptOe/",
    alt: "Thiruvambady Vineesh Marar — Instagram post",
  },
  {
    image: "instagram/Cv-FXeipz0U.jpg",
    url: "https://www.instagram.com/p/Cv-FXeipz0U/",
    alt: "Thiruvambady Vineesh Marar — Instagram post",
  },
  {
    image: "instagram/CrqoY1Hp77O.jpg",
    url: "https://www.instagram.com/p/CrqoY1Hp77O/",
    alt: "Thrissur Pooram — Instagram post",
  },
  {
    image: "instagram/CqNctbrj8Nv.jpg",
    url: "https://www.instagram.com/reel/CqNctbrj8Nv/",
    alt: "Thiruvambady Vineesh Marar — Instagram reel",
  },
  {
    image: "instagram/CqDuZ-WP8Va.jpg",
    url: "https://www.instagram.com/p/CqDuZ-WP8Va/",
    alt: "Thiruvambady Vineesh Marar — Instagram post",
  },
  {
    image: "instagram/CqDKMV_Pb1Q.jpg",
    url: "https://www.instagram.com/p/CqDKMV_Pb1Q/",
    alt: `${BRAND_NAME} — Instagram post`,
  },
  {
    image: "instagram/CqDJ8vbPZ53.jpg",
    url: "https://www.instagram.com/p/CqDJ8vbPZ53/",
    alt: `${BRAND_NAME} — Instagram post`,
  },
];

export default instagramPosts.map((post) => ({
  ...post,
  imageSrc: `${publicUrl}/${post.image}`,
}));
